<template>
  <div id="app" v-clack :style="{backgroundImage:'url(' + img + ')'}">
    <TheSideMove></TheSideMove>
    <TheFooter></TheFooter>
    <TheGoTop></TheGoTop>
    <!-- <router-view></router-view> -->
  </div>
</template>
<script>
const TheSideMove = () => import("@c/layout/TheSideMove.vue");
const TheFooter = () => import("@v/TheFooter.vue");
const TheGoTop = () => import("@c/project/TheGoTop.vue");
import img from "@a/img/backgroundImage.png";
import logo from "@a/img/logo.ico";

export default {
  name: 'App',
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }
    ],
    link: [
    { rel: 'shortcut icon', href: logo, type: 'image/x-icon' },
    ]
  },
  data: () => ({
    img: img,
    logo:logo
  }),
  components: {
    TheSideMove,
    TheFooter,
    TheGoTop
  }
};
</script>
<style lang="scss">
@import "@a/style/style.scss";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-position: 45% top;
  // min-height: 106vh;
  // min-height: 100vh;

  // #TheSide {
  //   width: 35%;
  //   width: 320px;
  //   height: 100vh;
  //   background-color: $color4;
  //   display: flex;
  //   flex-wrap: wrap;
  //   justify-content: center;
  //   align-items: center;
  // }

  #TheFooter {
    width: 100%;
    background-color: $color7;
    color: $color1;
    padding: 1rem 0;
    position: relative;
    bottom: 0;
  }

  #TheGoTop {
    position: fixed;
    right: 30px;
    bottom: 30px
  }

  #TheHome,
  #TheAboutMe,
  #ThePersonalTools,
  #TheAboutWebsite {
    &>div {
      padding: 1rem 2rem;
    }

    &>div:nth-of-type(2n+2) {
      background-color: $color11;
    }
  }

  #TheHome,
  #TheAboutMe,
  #ThePortfolio,
  #TheContactMe,
  #ThePersonalTools,
  #TheComponentTable,
  #TheAboutWebsite {
    background-color: $color1 !important;
    border-radius: 5px;
  }
}
</style>